/**
 * @module utils/columnSort/shared/compareUserGroup
 * @description 对照组虚拟列规则（场景 1 构建与场景 3 联动共用）
 */

import { SortableType } from '@dbl/core/chartEditor';
import type { IColumnSortItem } from '@/pages/datalab/pages/Multidimensional/Analysis/types/chartSettings/fieldColumnSort';
import { COLUMN_DISPLAY_TEXT } from '@/pages/datalab/pages/Multidimensional/Analysis/types/chartSettings/constants';
import { DATALAB_COMPARE_USER_FILTERS, normalizeColumnSortItem } from './keys';

/**
 * 是否应在 column_sort / 面板展示对照组虚拟列。
 *
 * - `hasUserFilters === false`：用户筛选总开关关闭；model 常仍保留多组 columnUserFilters，
 *   但不应展示对照组列（与 SwitchChartType 关闭开关行为一致）。
 * - `hasUserFilters` 未传：仅按组数判断（单测 / 无开关上下文的兼容路径）。
 */
export function shouldShowCompareUserGroup(
  columnUserFilters: unknown[] | undefined,
  hasUserFilters?: boolean,
): boolean {
  if (hasUserFilters === false) {
    return false;
  }
  if (!Array.isArray(columnUserFilters) || columnUserFilters.length <= 1) {
    return false;
  }
  return true;
}

/** QB 快照 / changeSet 上下文：对照组列是否应对用户可见 */
export function isCompareUserGroupActive(snapshot: {
  columnUserFilters?: unknown[];
  hasUserFilters?: boolean;
}): boolean {
  return shouldShowCompareUserGroup(
    snapshot.columnUserFilters,
    snapshot.hasUserFilters,
  );
}

export function createCompareUserGroupColumn(): IColumnSortItem {
  return normalizeColumnSortItem({
    table_id: '',
    table_code: '',
    column: DATALAB_COMPARE_USER_FILTERS,
    builder_type: SortableType.Dimension,
    column_display_cn: COLUMN_DISPLAY_TEXT.COMPARISON_GROUP.CN,
    column_display_en: COLUMN_DISPLAY_TEXT.COMPARISON_GROUP.EN,
  });
}
